module.exports = __webpack_public_path__ + "img/helpBg.166f877c.png";